import React from 'react';
import BaseVariables from '..';

function B340Variables() {
    return (
        <BaseVariables variableGroup="340B"/>
    );
}

export default B340Variables;
